import React, { useEffect, useState } from "react";
import moment from "moment";
import Select from "react-select";
import { allliststaff, grouplist } from "../../../services/admin";
import { bmamreportsummary } from "../../../services/bmam";
import { MANAGERROLE, PURPOSES, STATUSES } from "../bmam/addbmamreport";
import { purposelabel, statuslabel } from "../bmam/allbmamreport";
import exportUrl from "../../../exportUrl";

const today = moment().format("YYYY-MM-DD");
const monthstart = moment().startOf("month").format("YYYY-MM-DD");

/** Bootstrap badge colour per visit status. */
const STATUSBADGE = {
    very_good: "badge bg-success",
    good: "badge bg-primary",
    bad: "badge bg-danger",
};

/** Rows shown per page before the table starts paginating. */
const PERPAGE = 10;

export const BmamReport = () => {
    const [filterProduct, setFilterProduct] = useState([]);
    const [summary, setSummary] = useState(null);
    const [page, setPage] = useState(1);

    const [slist, setSlist] = useState([]);
    const [glist, setGlist] = useState([]);

    const [fdate, setFDate] = useState(monthstart);
    const [tdate, setTDate] = useState(today);
    const [otype, setOType] = useState("");
    const [staffid, setStaffId] = useState("");
    const [mgrpid, setMGrpId] = useState("");
    const [grpid, setGrpId] = useState("");
    const [purpose, setPurpose] = useState("");
    const [status, setStatus] = useState("");

    useEffect(() => {
        allliststaff(localStorage.getItem("branch")).then((res) => {
            if (res.status === true) {
                setSlist(res.data.details.filter((item) => item.role_id == MANAGERROLE));
            }
        });

        const temp = new FormData();
        temp.append("branch", localStorage.getItem("branch"));
        grouplist(temp).then((res) => {
            if (res.status === true) {
                const arr = res.data.map((item) => ({
                    value: item.id,
                    label: item.group_name,
                }));
                setGlist(arr);
            }
        });

        loadreport({ from_date: monthstart, to_date: today });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    function loadreport(filters = {}) {
        setFilterProduct([]);
        setSummary(null);
        setPage(1);

        const temp = new FormData();
        temp.append("branch_id", localStorage.getItem("branch"));
        temp.append("from_date", filters.from_date || "");
        temp.append("to_date", filters.to_date || "");
        temp.append("officer_type", filters.officer_type || "");
        temp.append("staff_id", filters.staff_id || "");
        temp.append("group_id", filters.group_id || "");
        temp.append("purpose", filters.purpose || "");
        temp.append("status", filters.status || "");

        bmamreportsummary(temp).then((res) => {
            if (res.status === true) {
                setFilterProduct(res.data.details);
                setSummary(res.data.summary);
            }
        });
    }

    function handlecenter(e) {
        if (e !== null) {
            setMGrpId(e);
            setGrpId(e.value);
        } else {
            setMGrpId("");
            setGrpId("");
        }
    }

    function handlesearch(e) {
        e.preventDefault();
        loadreport({
            from_date: fdate,
            to_date: tdate,
            officer_type: otype,
            staff_id: staffid,
            group_id: grpid,
            purpose: purpose,
            status: status,
        });
    }

    function handlereset() {
        setFDate(monthstart);
        setTDate(today);
        setOType("");
        setStaffId("");
        setMGrpId("");
        setGrpId("");
        setPurpose("");
        setStatus("");
        loadreport({ from_date: monthstart, to_date: today });
    }

    function downloadfile(dtype) {
        const params =
            "branch_id=" + (localStorage.getItem("branch") || "") +
            "&from_date=" + (fdate || "") +
            "&to_date=" + (tdate || "") +
            "&officer_type=" + (otype || "") +
            "&staff_id=" + (staffid || "") +
            "&group_id=" + (grpid || "") +
            "&purpose=" + (purpose || "") +
            "&status=" + (status || "") +
            "&type=" + dtype;
        window.open(exportUrl + "report/bmamdownload?" + params, "_blank");
    }

    // The download always exports every filtered row; paging is view only.
    const totalpages = Math.ceil(filterProduct.length / PERPAGE);
    const startindex = (page - 1) * PERPAGE;
    const pagedrows = filterProduct.slice(startindex, startindex + PERPAGE);

    return (
        <div>
            <div className="page-header">
                <h2 className="main-content-title tx-24 mg-b-5">BM &amp; AM Daily Report</h2>
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <a>Report</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                        BM &amp; AM Daily Report
                    </li>
                </ol>
            </div>

            <div className="content-body">
                <div className="row">
                    <div className="col-xl-12">
                        <div className="card">
                            <div className="card-header">
                                <h2 className="main-content-title tx-24 mg-b-5">
                                    BM &amp; AM Daily Report
                                </h2>
                            </div>
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-xl-3 col-sm-6">
                                        <div className="mb-3">
                                            <label className="form-label">From Date</label>
                                            <input
                                                type="date"
                                                className="form-control"
                                                value={fdate}
                                                onChange={(e) => setFDate(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-xl-3 col-sm-6">
                                        <div className="mb-3">
                                            <label className="form-label">To Date</label>
                                            <input
                                                type="date"
                                                className="form-control"
                                                value={tdate}
                                                onChange={(e) => setTDate(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-xl-3 col-sm-6">
                                        <div className="mb-3">
                                            <label className="form-label">BM / AM</label>
                                            <select
                                                className="default-select form-control wide"
                                                value={otype}
                                                onChange={(e) => setOType(e.target.value)}
                                            >
                                                <option value="">All</option>
                                                <option value="BM">BM</option>
                                                <option value="AM">AM</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-xl-3 col-sm-6">
                                        <div className="mb-3">
                                            <label className="form-label">Name</label>
                                            <select
                                                className="default-select form-control wide"
                                                value={staffid}
                                                onChange={(e) => setStaffId(e.target.value)}
                                            >
                                                <option value="">All</option>
                                                {slist.map((item, index) => {
                                                    return (
                                                        <option key={index} value={item.id}>
                                                            {item.staff_name}
                                                        </option>
                                                    );
                                                })}
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-xl-3 col-sm-6">
                                        <div className="mb-3">
                                            <label className="form-label">Center Name</label>
                                            <Select
                                                className="default-select"
                                                placeholder="All Centers"
                                                value={mgrpid}
                                                options={glist}
                                                onChange={handlecenter}
                                                isSearchable={true}
                                                isClearable
                                            />
                                        </div>
                                    </div>
                                    <div className="col-xl-3 col-sm-6">
                                        <div className="mb-3">
                                            <label className="form-label">Purpose of Visit</label>
                                            <select
                                                className="default-select form-control wide"
                                                value={purpose}
                                                onChange={(e) => setPurpose(e.target.value)}
                                            >
                                                <option value="">All</option>
                                                {PURPOSES.map((item, index) => {
                                                    return (
                                                        <option key={index} value={item.value}>
                                                            {item.label}
                                                        </option>
                                                    );
                                                })}
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-xl-3 col-sm-6">
                                        <div className="mb-3">
                                            <label className="form-label">Status</label>
                                            <select
                                                className="default-select form-control wide"
                                                value={status}
                                                onChange={(e) => setStatus(e.target.value)}
                                            >
                                                <option value="">All</option>
                                                {STATUSES.map((item, index) => {
                                                    return (
                                                        <option key={index} value={item.value}>
                                                            {item.label}
                                                        </option>
                                                    );
                                                })}
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-xl-3 col-sm-6 mt-4">
                                        <div className="text-end">
                                            <a className="btn btn-secondary me-2" onClick={handlereset}>
                                                Reset
                                            </a>
                                            <a className="btn btn-primary" onClick={handlesearch}>
                                                Search
                                            </a>
                                        </div>
                                    </div>
                                </div>

                                <div className="text-end mb-3">
                                    <a
                                        className="btn btn-danger me-2"
                                        onClick={() => downloadfile("pdf")}
                                    >
                                        Download PDF
                                    </a>
                                    <a
                                        className="btn btn-success"
                                        onClick={() => downloadfile("excel")}
                                    >
                                        Download Excel
                                    </a>
                                </div>

                                {summary !== null && (
                                    <div className="row mb-3">
                                        <div className="col-xl-3 col-sm-6">
                                            <p>Total Visits : {summary.total}</p>
                                        </div>
                                        <div className="col-xl-3 col-sm-6">
                                            <p>Very Good : {summary.very_good}</p>
                                        </div>
                                        <div className="col-xl-3 col-sm-6">
                                            <p>Good : {summary.good}</p>
                                        </div>
                                        <div className="col-xl-3 col-sm-6">
                                            <p>Bad : {summary.bad}</p>
                                        </div>
                                        {summary.purpose &&
                                            PURPOSES.map((item, index) => {
                                                return (
                                                    <div className="col-xl-3 col-sm-6" key={index}>
                                                        <p>
                                                            {item.label} : {summary.purpose[item.value]}
                                                        </p>
                                                    </div>
                                                );
                                            })}
                                    </div>
                                )}

                                <div className="table-container">
                                    <table className="responsive-table">
                                        <thead>
                                            <tr>
                                                <th>S.No</th>
                                                <th>Date</th>
                                                <th>BM / AM</th>
                                                <th>Name</th>
                                                <th>Center Name</th>
                                                <th>Purpose of Visit</th>
                                                <th>Status</th>
                                                <th>Reports</th>
                                                <th>Remark</th>
                                                <th>BM Signature</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {pagedrows.map((item, index) => {
                                                return (
                                                    <tr key={index}>
                                                        <td>{startindex + index + 1}</td>
                                                        <td>
                                                            {item.report_date !== null
                                                                ? moment(item.report_date).format("DD-MM-YYYY")
                                                                : ""}
                                                        </td>
                                                        <td>{item.officer_type}</td>
                                                        <td>{item.staff_name}</td>
                                                        <td>
                                                            {item.all_centers
                                                                ? "All Center's View"
                                                                : item.group_name}
                                                        </td>
                                                        <td>{purposelabel(item.purpose)}</td>
                                                        <td>
                                                            <span
                                                                className={
                                                                    STATUSBADGE[item.status] ||
                                                                    "badge bg-secondary"
                                                                }
                                                            >
                                                                {statuslabel(item.status)}
                                                            </span>
                                                        </td>
                                                        <td>{item.report}</td>
                                                        <td>{item.remark}</td>
                                                        <td>{item.bm_signature}</td>
                                                    </tr>
                                                );
                                            })}
                                            {filterProduct.length === 0 && (
                                                <tr>
                                                    <td colSpan={10}>No Records Found</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>

                                {totalpages > 1 && (
                                    <div className="d-flex justify-content-between align-items-center flex-wrap mt-3">
                                        <div>
                                            Showing {startindex + 1} to{" "}
                                            {startindex + pagedrows.length} of{" "}
                                            {filterProduct.length} entries
                                        </div>
                                        <ul className="pagination mb-0">
                                            <li
                                                className={
                                                    page === 1
                                                        ? "page-item disabled"
                                                        : "page-item"
                                                }
                                            >
                                                <a
                                                    className="page-link"
                                                    onClick={() => setPage(page - 1)}
                                                >
                                                    Previous
                                                </a>
                                            </li>
                                            {Array.from(
                                                { length: totalpages },
                                                (item, index) => index + 1
                                            ).map((pno) => {
                                                return (
                                                    <li
                                                        className={
                                                            pno === page
                                                                ? "page-item active"
                                                                : "page-item"
                                                        }
                                                        key={pno}
                                                    >
                                                        <a
                                                            className="page-link"
                                                            onClick={() => setPage(pno)}
                                                        >
                                                            {pno}
                                                        </a>
                                                    </li>
                                                );
                                            })}
                                            <li
                                                className={
                                                    page === totalpages
                                                        ? "page-item disabled"
                                                        : "page-item"
                                                }
                                            >
                                                <a
                                                    className="page-link"
                                                    onClick={() => setPage(page + 1)}
                                                >
                                                    Next
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BmamReport;
